module.exports = __webpack_public_path__ + "static/media/Platformbanner.4643f431.png";